(function ($) {
    $.fn.inputCounter = function (payloadDelimiter) {

        function len(value) {
            return payloadDelimiter ? value.split(payloadDelimiter).join('').length : value.length;
        }

        function updateCounter(input, updateGroup) {
            var length = len(input.val()),
                counter = $('#' + input.data('counter')),
                max = +input.data('counterMax'),
                groupMax = +input.data('counterGroupMax'),
                groupClass = input.data('counterGroup'),
                group = groupClass ? $('.' + groupClass) : null;

            if (group) {
                var groupLength = group.map(function () {
                    return len($(this).val());
                }).get().reduce(function (memo, length) {
                    return memo + length;
                }, 0);
                counter.html(length + '&nbsp;/&nbsp;' + (groupMax - groupLength));
                counter.toggleClass('error', groupLength > groupMax || length > max);

                if (updateGroup) {
                    group.each(function () { updateCounter($(this)); });
                }
            } else {
                counter.html(max - length);
                counter.toggleClass('error', length > max);
            }
        }

        return this.each(function () {
            $(this).keyup(function () {
                updateCounter($(this), true);
            }).keyup();
        });
    };
})(jQuery);
